window.addEventListener('load', () => {
    document.querySelectorAll('.js-logo-scroller').forEach((scroller) => {
        const container = scroller.parentElement;
        const originalItems = [...scroller.children];
        if (originalItems.length === 0) return;

        let copies = 1;

        do {
            originalItems.forEach((item) => {
                const clone = item.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                scroller.appendChild(clone);
            });
            copies++;
        } while (scroller.scrollWidth < container.offsetWidth * 2 || copies % 2 !== 0);

        // Use exact integer pixel value to avoid subpixel rendering artifacts at the loop point
        scroller.style.setProperty('--logo-scroll-amount', `-${Math.round(scroller.scrollWidth / 2)}px`);
        scroller.style.animation = 'logo-scroll 20s linear infinite';
    });
});
